<template>
	<header
		class="flex items-center border-0 h-max"
		:class="[
			heading ? 'justify-between' : 'justify-end',
			inline ? '' : 'mb-6'
		]"
	>
		<h3
			v-if="heading"
			class="mb-0 text-xl leading-none text-white uppercase font-heading"
		>
			{{ heading }}
		</h3>

		<div class="flex items-center gap-3">
			<slot name="actions" />
			<div
				class="flex items-center space-x-2 cursor-pointer"
				@click="modalOpen = true"
			>
				<div class="flex items-center justify-center">
					<IconInfoCircle size="20" />
				</div>
				<span class="hidden md:inline-block">
					{{ modalTrigger }}
				</span>
			</div>
		</div>

		<TraitsInfoModal v-model="modalOpen" :wheel-mode="wheelMode" />
	</header>
</template>

<script>
import { IconInfoCircle } from '~/components/Icons'
import { TraitsInfoModal } from '.'

export default {
	name: 'OverviewHeader',
	components: {
		IconInfoCircle,
		TraitsInfoModal
	},
	props: {
		heading: {
			type: String,
			default: ''
		},
		inline: {
			type: Boolean,
			default: false
		},
		wheelMode: {
			type: String,
			required: true,
			validator: value =>
				['applicant', 'job', 'comparison'].includes(value)
		}
	},
	data() {
		return {
			modalOpen: false
		}
	},
	computed: {
		modalTrigger() {
			return this.$t('personality_results.overview.header.modal_trigger')
		}
	}
}
</script>
